import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { addUtils, applyDefaultClass } from './class-name-helpers';

const Paragraph = ({
  className,
  headline,
  headlineFeature,
  intro,
  body,
  sub,
  strongSub,
  heavy,
  bodyHeavy,
  dossierBody,
  dossierBodyHeavy,
  dossierIntro,
  dossierIntroHeavy,
  ...props
}) => {
  const variants = {
    'ss_para--headline': headline,
    'ss_para--headline-feature': headlineFeature,
    'ss_para--intro': intro,
    'ss_para--body': body,
    'ss_para--sub': sub,
    'ss_para--strong-sub': strongSub,
    'ss_para--heavy': heavy,
    'ss_para--body-heavy': bodyHeavy,
    'ss_para--dossier-body': dossierBody,
    'ss_para--dossier-body-heavy': dossierBodyHeavy,
    'ss_para--dossier-intro': dossierIntro,
    'ss_para--dossier-intro-heavy': dossierIntroHeavy,
  };
  const defaultClassName = applyDefaultClass(variants, 'ss_para--body');
  const { utilClassNames, restProps } = addUtils(props);

  return (
    <p className={clsx(className, defaultClassName, variants, utilClassNames)} {...restProps} />
  );
};

Paragraph.defaultProps = {
  headline: false,
  intro: false,
  body: false,
  sub: false,
  strongSub: false,
  headlineFeature: false,
  heavy: false,
  bodyHeavy: false,
  className: '',
  dossierBody: false,
  dossierBodyHeavy: false,
  dossierIntro: false,
  dossierIntroHeavy: false,
};

Paragraph.propTypes = {
  headline: PropTypes.bool,
  headlineFeature: PropTypes.bool,
  intro: PropTypes.bool,
  body: PropTypes.bool,
  sub: PropTypes.bool,
  strongSub: PropTypes.bool,
  heavy: PropTypes.bool,
  bodyHeavy: PropTypes.bool,
  className: PropTypes.string,
  dossierBody: PropTypes.bool,
  dossierBodyHeavy: PropTypes.bool,
  dossierIntro: PropTypes.bool,
  dossierIntroHeavy: PropTypes.bool,
};

export default Paragraph;
